import { BsFiletypeHtml, BsFiletypeCss, BsBootstrap } from "react-icons/bs";
import { AiFillApi } from "react-icons/ai";
import { FaNodeJs, FaDatabase } from "react-icons/fa";
import { GrTroubleshoot, GrHost } from "react-icons/gr";
import {
  SiJavascript,
  SiReact,
  SiTailwindcss,
  SiMongodb,
  SiGithub,
  SiExpress,
  SiCanva,
  SiFreelancer,
} from "react-icons/si";
export const TechstackList = [
  {
    _id: 1,
    name: "HTML",
    icon: BsFiletypeHtml,
  },
  {
    _id: 2,
    name: "CSS / CSS3",
    icon: BsFiletypeCss,
  },
  {
    _id: 3,
    name: "Bootstrap",
    icon: BsBootstrap,
  },
  {
    _id: 4,
    name: "Javascript",
    icon: SiJavascript,
  },
  {
    _id: 5,
    name: "React.js",
    icon: SiReact,
  },
  {
    _id: 6,
    name: "Tailwind ",
    icon: SiTailwindcss,
  },
  {
    _id: 7,
    name: "Node.js ",
    icon: FaNodeJs,
  },
  {
    _id: 8,
    name: "Express.js ",
    icon: SiExpress,
  },
  {
    _id: 9,
    name: "APIs ",
    icon: AiFillApi,
  },
  {
    _id: 10,
    name: "Mongodb ",
    icon: SiMongodb,
  },
  {
    _id: 11,
    name: "Git / Github ",
    icon: SiGithub,
  },
  {
    _id: 12,
    name: "Troubleshooting",
    icon: GrTroubleshoot,
  },
  {
    _id: 13,
    name: "Canva ",
    icon: SiCanva,
  },
  {
    _id: 14,
    name: "Freelancer ",
    icon: SiFreelancer,
  },
  {
    _id: 15,
    name: "Hosting ",
    icon: GrHost,
  },
  {
    _id: 16,
    name: "Database ",
    icon: FaDatabase,
  },
];
